import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ns-block ns-relative ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({ width: 3 })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                // scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (pages.length > 1 && (
        <nav class="ns-pagination ns-w-100" role="navigation">
            <ol class="ns-pagination-list ns-flex ns-flex-nowrap ns-items-center ns-justify-center">
                {prev && (
                    <li class="ns-prev-item">
                        <PageLink {...pageLinkProps(prev)} className="ns-previous">
                            <span class="sr-only visually-hidden">Previous page</span>
                            <svg role="presentation" aria-hidden="true" width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.50006 15C7.7219 15 7.94462 14.9155 8.11457 14.7451C8.454 14.4057 8.454 13.8564 8.11457 13.517L2.0972 7.50006L8.11457 1.48269C8.454 1.14327 8.454 0.593506 8.11457 0.254568C7.77515 -0.084856 7.22539 -0.084856 6.88604 0.254568L0.255057 6.88555C-0.0843658 7.22498 -0.0843658 7.77474 0.255057 8.11368L6.88604 14.7451C7.05543 14.915 7.27775 15 7.50006 15Z" fill="#010002"/>
                            </svg>
                        </PageLink>
                    </li>
                )}

                {first && (
                    <>
                        <li>
                            <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                                {first.page}
                            </PageLink>
                        </li>
                        <li class="ns-pagination-spacer"><span>...</span></li>
                    </>
                )}

                {pages.map((page, index) => {
                    const shouldHideMobile = (window.innerWidth < 640) && (
                        (first && last && pages.length === 3 && index === 0) || 
                        (!first && last && pages.length === 4 && index === 1) || 
                        // (!first && last && pages.length === 4 && index === 3) || //show next button
                        // (first && last && pages.length === 3 && index === 2) || //show next button
                        (first && !last && pages.length === 4 && index === 0) ||
                        (first && !last && pages.length === 4 && index === 2)
                    );

                    return (
                        <Fragment key={page.page}>
                            {!first && pages.length === 4 && index === 1 && (
                                <li class="ns-pagination-spacer ns-desktop-pagination-hidden"><span>...</span></li>
                            )}
    
                            <li key={page.page} class={`${page.current ? "ns-active" : shouldHideMobile ? "ns-pagination-mobile-hidden" : ''}`}>
                                <PageLink ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>{page.page}</PageLink>
                            </li>
    
                            {!last && pages.length === 4 && index === 2 && (
                                <li class="ns-pagination-spacer ns-desktop-pagination-hidden"><span>...</span></li>
                            )}
                        </Fragment>
                    )})
                }
            
                {last && (
                    <>
                        <li class="ns-pagination-spacer"><span>...</span></li>
                        <li>
                            <PageLink {...pageLinkProps(last)} ariaLabel="Last page">{last.page}</PageLink>
                        </li>
                    </>
                )}

                {next && (
                    <li class="ns-next-item">
                        <PageLink {...pageLinkProps(next)} className={`ns-next ${next ? '' : 'ns-disabled'}`}>
                            <span class="sr-only visually-hidden">Next page</span>
                            <svg style={{transform: "rotate(180deg)"}} role="presentation" aria-hidden="true" width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.50006 15C7.7219 15 7.94462 14.9155 8.11457 14.7451C8.454 14.4057 8.454 13.8564 8.11457 13.517L2.0972 7.50006L8.11457 1.48269C8.454 1.14327 8.454 0.593506 8.11457 0.254568C7.77515 -0.084856 7.22539 -0.084856 6.88604 0.254568L0.255057 6.88555C-0.0843658 7.22498 -0.0843658 7.77474 0.255057 8.11368L6.88604 14.7451C7.05543 14.915 7.27775 15 7.50006 15Z" fill="#010002"/>
                            </svg>
                        </PageLink>
                    </li>
                )}
            </ol>
        </nav>
    ))
}